import React from "react";
import { resolveMediaUrl } from "@/lib/api";

/**
 * Renders either an <img> or a looping muted <video> preview depending on
 * `mediaType`, so admin-uploaded photos AND videos render identically sized
 * across Gold / Silver product cards and category tiles.
 *
 * Includes basic anti-copy deterrents (blocks right-click "save image",
 * drag-and-drop saving, and long-press-to-save on mobile). This stops
 * casual copying but — like on any website — can't stop screenshots or
 * someone inspecting the page's network requests directly.
 */
const preventContextMenu = (e) => e.preventDefault();

export const MediaTile = ({
  src,
  mediaType = "image",
  alt = "",
  className = "",
  objectPosition = "center",
}) => {
  const resolved = resolveMediaUrl(src);
  if (!resolved) return null;

  if (mediaType === "video") {
    return (
      <video
        src={resolved}
        className={className}
        style={{ objectPosition }}
        autoPlay
        muted
        loop
        playsInline
        controlsList="nodownload noremoteplayback"
        disablePictureInPicture
        onContextMenu={preventContextMenu}
      />
    );
  }

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      style={{ objectPosition, WebkitUserDrag: "none", userSelect: "none" }}
      loading="lazy"
      draggable={false}
      onContextMenu={preventContextMenu}
    />
  );
};
